import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

export function LineItemsPackagingTypeQuestionBubble() {
  return (
    <Tooltip
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">Packaging Type</T>
          <T size="xs" color="secondary">
            Carriers need to know how a dangerous item is packaged. Please enter
            the type of packaging inside each handling unit
          </T>
          <T size="xs" color="secondary">
            eg. If you are shipping a crate containing 50 bags, enter bag. If
            you are shipping a drum that is not further subdivided, enter drum
          </T>
        </Stack>
      }
    />
  );
}
